import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getScrollTargetForCurrentUrl } from "@/lib/authReturn";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Don't fight the auth-return scroll restorer.
    const target = getScrollTargetForCurrentUrl();
    if (target != null && target > 0) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
